import { html } from "lit-html"

const DefaultRow = ({ name, url }) => html`
  <div class="p-3 pb-0 relative flex flex-row flex-wrap">
    <div class="min-h-11 p-3 order-1">
      <a class="text-blue hover:text-red" href=${url}>${name}</a>
    </div>
    <hr class="divider m-3 mb-0 order-10" />
  </div>
`

export default DefaultRow
